const environment = localStorage.getItem("environment");

const baseUrls = {
  Prod: "https://prod.baas.batterypool.com",
  Test: "https://test.baas.batterypool.com",
};

const getBaseUrl = () => baseUrls[environment] || baseUrls["Test"];

export { getBaseUrl };
